import { get } from '../helper/api'
import app_config from '../config/app.json';
const api_url = app_config.api_root + '/api/recruit/';

export const reciveData = status => ({
  type: 'RECIVE_DATA',
  payload: { status }
})


export const fetchData = value => {
  return async (dispatch,getState) => {
      get(api_url,value)
      .then((response) => {
        dispatch(reciveData(response))
      })
      .catch((e) => {
        console.log("server-error");
      })

  }
}


// WEBPACK FOOTER //
// ./src/actions/recruit.js